import DiscountsService from "@/api/services/discounts";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const response = await DiscountsService.fetchIndex(params);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async create(_, { discountType, offeredMonths, finalPrice }) {
      const params = { discountType, offeredMonths };
      if (discountType === "discount") params.finalPrice = finalPrice;
      return await DiscountsService.create(params);
    },
  },
};
